import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {menuCategoriesService} from "../../../services/settings-services";


const initialState = {
    menuCategories: [],
    status: null,
    error: null,
    trigger: 0,
}

const getAllMenuCategories = createAsyncThunk(
    'menuCategoriesSlice/getAllMenuCategories',
    async (_, {rejectWithValue}) => {
        try {
            return await menuCategoriesService.getAll();
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const menuCategoriesSlice = createSlice({
    name: "menuCategoriesSlice",
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllMenuCategories.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllMenuCategories.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.menuCategories = action.payload;
            })
            .addCase(getAllMenuCategories.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: menuCategoriesReducer, actions} = menuCategoriesSlice;
const menuCategoriesActions = {
    ...actions,
    getAllMenuCategories
}

export {
    menuCategoriesReducer,
    menuCategoriesActions
}


